export const CREDIT_COSTS = {
  mockup_normal: 1,
  ai_adapt: 2,
  remove_bg: 1,
  export_8k: 3,
};

export const PACKAGES = [
  { lookup_key: "credits_20", credits: 20, price: "4,99 €", tag: "Prueba" },
  { lookup_key: "credits_100", credits: 100, price: "14,99 €", tag: "Popular", popular: true },
  { lookup_key: "credits_300", credits: 300, price: "34,99 €", tag: "Estudio" },
];

export const ACTION_LABELS = {
  mockup_normal: "Mockup generado",
  ai_adapt: "Adaptación con IA",
  remove_bg: "Eliminar fondo",
  export_8k: "Exportación 8K",
  purchase: "Compra de créditos",
  signup_bonus: "Bono de bienvenida",
};

export const STATUS_LABELS = {
  waiting: "En espera",
  production: "En producción",
  done: "Completado",
};
